import styled from 'styled-components';
import { BREAKPOINTS } from '@src/styles/config';

const StyledVoiceList = styled.div`
  &.card {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    @media (min-width: ${BREAKPOINTS.MLG}px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (max-width: ${BREAKPOINTS.SMX}px) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  &.list {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${({ isLeaderboard }) => (isLeaderboard ? '16px' : '4px')};
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    background-color: #fff;
  }
`;

const StyledNoDataVoiceList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 100%;
  padding-top: 5%;
`;

export { StyledVoiceList, StyledNoDataVoiceList };
